
/** Pads any numeric ID (e.g. Claim No, Policy No, etc.) */
export const formatPaddedId = (id?: number | null, padLength: number = 5): string => {
    if (id == null) return "-";
    return id.toString().padStart(padLength, "0");
};